import roleNameMatches from "./roleNameMatches";


function canViewStatus(status, auth, state = null){
    const {
        user: {
            user: {id: userID, role: {name: roleName}},
            permissions: {workUnassignedCases} = {},
        },
        isAdmin
    } = auth;

    
    let newValidation = false;
    if(state && state["assigned.crm"] === userID){
        newValidation = roleNameMatches(status.role, 'customer-relationship-manager-retail');
    }

    if(state && state["assigned.crmm"] === userID){
        newValidation = roleNameMatches(status.role, 'customer-relationship-market-manager-retail');
    }

    return isAdmin || ((roleNameMatches(status.role, roleName) || workUnassignedCases || newValidation) && status.canEdit !== false);
}


export default canViewStatus;